import { React, useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Checkbox } from 'flowbite-react';
import LoadingSpinner from '../../components/LoadingSpinner';

const AreaList = ({ onClose, roleId }) => {
    const [areas, setAreas] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = async (id, checked) => {
        setAreas((prevAreas) =>
            prevAreas.map((area) =>
                area.id === id
                    ? { ...area, checked: !area.checked }
                    : area
            )
        );

        setIsLoading(true);
        try {
            await axios.post(
                `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/rolearea/${roleId}/findorcreate`,
                {
                    areaId: id
                },
                {
                    withCredentials: true,
                }
            );
        } catch (err) {
            setError('Error al actualizar el área del rol');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const getAreasByRole = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(
                    `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/rolearea/${roleId}`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setAreas(response.data.areas);
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };
        getAreasByRole();
    }, [roleId]);

    return (
        <>
            {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue" />}
            {error && <div className="text-red-500 mb-2">{error}</div>}
            <div className="overflow-x-auto">
                <Table hoverable>
                    <Table.Head>
                        <Table.HeadCell className="p-2"></Table.HeadCell>
                        <Table.HeadCell>Area</Table.HeadCell>
                        <Table.HeadCell>Descripción</Table.HeadCell>
                        <Table.HeadCell>Estado</Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {areas.map((area) => (
                            <Table.Row key={area.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <Table.Cell className="p-2">
                                    <Checkbox
                                        key={area.id}
                                        name="checkArea"
                                        onChange={() => handleChange(area.id, area.checked)}
                                        checked={area.checked}
                                    />
                                </Table.Cell>
                                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                    {area.name}
                                </Table.Cell>
                                <Table.Cell>{area.description}</Table.Cell>
                                <Table.Cell>{(parseInt(area.status) === 1) ? 'Activo' : 'Inactivo'}</Table.Cell>
                            </Table.Row>
                        ))}

                    </Table.Body>
                </Table>
            </div>
        </>
    );
};

export default AreaList;

